import { getRefreshToken, request, setTokens } from './client.js'

export interface RoleGrant {
  readonly role: string
  readonly scope: 'NASIONAL' | 'REGIONAL' | 'TUK'
  readonly scopeRef: string | null
}

export interface SessionUser {
  readonly id: string
  readonly username: string
  readonly fullName: string
  readonly roles: readonly RoleGrant[]
}

interface LoginResponse {
  readonly accessToken: string
  readonly refreshToken: string
  readonly user: SessionUser
}

export async function login(username: string, password: string): Promise<SessionUser> {
  const data = await request<LoginResponse>('/api/v1/auth/login', {
    method: 'POST',
    body: { username, password },
    skipRefresh: true,
  })
  setTokens(data.accessToken, data.refreshToken)
  return data.user
}

export async function logout(): Promise<void> {
  const refreshToken = getRefreshToken()
  if (refreshToken !== null) {
    await request('/api/v1/auth/logout', {
      method: 'POST',
      body: { refreshToken },
      skipRefresh: true,
    }).catch(() => undefined) // logout lokal tetap berjalan meski server tak terjangkau
  }
  setTokens(null, null)
}

export async function me(): Promise<SessionUser> {
  return request<SessionUser>('/api/v1/auth/me')
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await request('/api/v1/auth/change-password', {
    method: 'POST',
    body: { currentPassword, newPassword },
  })
  // Server mencabut seluruh refresh token; sesi lokal ikut ditutup rapi.
  setTokens(null, null)
}
